module.exports = "<label for=\"{{id}}\">{{label}} <sup *ngIf=\"required\"> *</sup></label>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/form/label/label.component.html
// module id = ../../../../../src/app/components/form/label/label.component.html
// module chunks = main